import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {KeycloakAuthGuard, KeycloakService} from 'keycloak-angular';
import {UserUtil} from '../utils/user-utils';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      const idpHint = route.queryParams['idp'] || route.queryParams['idpHint'] || route.queryParams['kc_idp_hint'];
      const loginOptions: Keycloak.KeycloakLoginOptions = {
        redirectUri: window.location.origin + state.url
      };
      
      if (idpHint) {
        loginOptions.idpHint = idpHint;
      }
      
      await this.keycloak.login(loginOptions);
    }

    this.router.navigate([UserUtil.getDefaultRoute(this.roles)]);

    return this.authenticated;
  }
}
